import { render, staticRenderFns } from "./PlaysOverview.vue?vue&type=template&id=0aca408c&scoped=true"
import script from "./PlaysOverview.vue?vue&type=script&lang=js"
export * from "./PlaysOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aca408c",
  null
  
)

export default component.exports